<template>
  <v-btn-toggle
    v-model="valueInner"
    class="p-btn-toggle-primary"
    dense
  >
    <v-btn
      v-for="item of accessOptions"
      :key="item.value"
      :value="item.value"
      :disabled="!hasAccess()"
    >
      {{ item.text }}
    </v-btn>
  </v-btn-toggle>
</template>


<script>
import accessMixin from '@/mixins/access.mixin'

export default {
  mixins: [
    accessMixin
  ],

  inheritAttrs: false,


  props: {
    value: Boolean
  },


  data () {
    return {
    }
  },


  computed: {
    valueInner: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val ?? null)
      }
    },

    accessOptions () {
      return [
        { value: true, text: this.$t('scheme.accessOptions.write') },
        { value: false, text: this.$t('scheme.accessOptions.read') }
      ]
    }
  }
}
</script>
